import { useQuery } from '@apollo/client/react';
import { inLifeQuotingFieldsData, personEntityData } from '@in-life/constants';
import { ReactNode, createContext, useContext } from 'react';

import { gql } from '@generated/gql';
import { CustomerProfileInformationQuery } from '@generated/gql/graphql';

const customerProfileInformationQuery = gql(`
  query CustomerProfileInformation {
    profileInformation {
      ... on PartnerProfileInformation {
        name
        partnerPositionId
        partnerId
        handle
        isCorporate
        canDiscussInsurance
      }
      ... on SalesProfileInformation {
        email
      }
      ... on CustomerProfileInformation {
        accountNumber
        personId
      }
    }
  }
`);

type CustomerProfileInfoContextValue = {
  accountNumber: string | null;
};

const CustomerProfileInfoContext =
  createContext<Nullable<CustomerProfileInfoContextValue>>(null);

export const useCustomerProfileInfoContext = () => {
  return useContext(CustomerProfileInfoContext);
};

export const CustomerProfileInfoProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { data, loading } = useQuery<CustomerProfileInformationQuery>(
    customerProfileInformationQuery
  );

  const accountNumber =
    data?.profileInformation?.__typename === 'CustomerProfileInformation'
      ? data.profileInformation.accountNumber || null
      : null;

  const personId =
    data?.profileInformation?.__typename === 'CustomerProfileInformation'
      ? data.profileInformation.personId || null
      : null;

  if (accountNumber) {
    inLifeQuotingFieldsData.account_number = accountNumber;
  }

  if (personId) {
    personEntityData.personId = personId;
  }

  if (loading) {
    return null;
  }

  return (
    <CustomerProfileInfoContext value={{ accountNumber }}>
      {children}
    </CustomerProfileInfoContext>
  );
};
